export const MenuItems = [
  {
    title: 'Adult and Child',
    path: '/Adult and Child',
    cName: 'dropdown-link',
  },
  {
    title: 'Boating',
    path: '/Boating',
    cName: 'dropdown-link',
  },
  {
    title: 'Pets and People',
    path: '/Pets and People',
    cName: 'dropdown-link',
  },
  {
    title: 'Wedding',
    path: '/Weddings',
    cName: 'dropdown-link',
  },
  {
    title: 'Posthumous',
    path: '/Posthumous',
    cName: 'dropdown-link',
  },
  {
    title: 'Fallen Heroes',
    path: '/Fallen Heroes',
    cName: 'dropdown-link',
  },
]

export const Menu = [
  {
    title: 'Self-Portrait',
    path: '/Self-Portrait',
    cName: 'dropdown-link',
  },
  {
    title: 'Mixed and Other',
    path: '/Mixed and Other',
    cName: 'dropdown-link',
  },
  {
    title: 'Pastel',
    path: '/Pastel',
    cName: 'dropdown-link',
  },
  {
    title: 'Corporate and Groups',
    path: '/Corporate and Groups',
    cName: 'dropdown-link',
  },
  {
    title: 'Sibling Indoors',
    path: '/Sibling Indoors',
    cName: 'dropdown-link',
  },
  {
    title: 'Sports,Non-Pro',
    path: '/Sports,Non-Pro',
    cName: 'dropdown-link',
  },
]
